import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
  defaults: { VApp: { class: 'coupon-builder' } },
  theme: {
    defaultTheme: 'light',
    variations: { colors: [], lighten: 0, darken: 0 },
  },
  directives,
  components,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
})
